import { usePaymentApi } from "../api/PaymentApiClient";
import { PaymentFrontendService } from "../services/PaymentFrontendService";

export const usePaymentService = (): PaymentFrontendService =>
  new PaymentFrontendService(usePaymentApi());
